(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-model-archive"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iv-model-archive')) {
    customElements.define('iv-model-archive', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const form = this.querySelector('form');
        const grid = this.querySelector('.iv-archive-grid');
        if (!form || !grid) return;
        let cards = [...grid.querySelectorAll('[data-iv-archive-card]')];
        const seen = new Set(cards.map(card => card.dataset.modelId));
        const initialPage = Number(this.dataset.currentPage);
        const totalPages = Number(this.dataset.totalPages);
        let complete = totalPages <= 1;
        let loading = false;
        let failed = false;
        let resultPage = 1;
        let filtered = cards;
        const pageSize = 24;
        const normalize = text => String(text).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
        const fillOptions = () => {
          for (const name of ['brand', 'scale']) {
            const select = form.elements.namedItem(name);
            const selected = select.value;
            select.querySelectorAll('option:not(:first-child)').forEach(option => option.remove());
            [...new Set(cards.map(card => card.dataset[name]).filter(Boolean))].sort().forEach(value => select.add(new Option(value, value)));
            select.value = selected;
          }
        };
        const update = () => {
          const terms = normalize(form.elements.namedItem('model-search').value).split(/\s+/).filter(Boolean);
          const brand = form.elements.namedItem('brand').value;
          const scale = form.elements.namedItem('scale').value;
          const inStock = form.elements.namedItem('in-stock').checked;
          filtered = cards.filter(card => terms.every(term => normalize(card.textContent).includes(term)) && (!brand || card.dataset.brand === brand) && (!scale || card.dataset.scale === scale) && (!inStock || card.dataset.stock === 'yes'));
          const pages = Math.max(1, Math.ceil(filtered.length / pageSize));
          resultPage = Math.min(resultPage, pages);
          const visible = new Set(filtered.slice((resultPage - 1) * pageSize, resultPage * pageSize));
          cards.forEach(card => { card.hidden = !visible.has(card); });
          this.querySelector('[data-iv-count]').textContent = complete ? String(filtered.length) : '…';
          this.querySelector('[data-iv-no-results]').hidden = !complete || filtered.length > 0;
          this.querySelector('[data-iv-loading]').hidden = !loading;
          this.querySelector('[data-iv-error]').hidden = !failed;
          this.querySelector('[data-iv-server-pages]').hidden = complete;
          this.querySelector('[data-iv-client-pages]').hidden = !complete || pages <= 1;
          this.querySelector('[data-iv-page-status]').textContent = resultPage + ' / ' + pages;
          this.querySelector('[data-iv-previous]').disabled = resultPage <= 1;
          this.querySelector('[data-iv-next]').disabled = resultPage >= pages;
        };
        const loadAll = async () => {
          if (complete || loading) return;
          loading = true;
          failed = false;
          update();
          try {
            const first = new URL(this.dataset.firstUrl, window.location.href);
            if (first.origin !== window.location.origin) throw new Error('origin');
            for (let page = 1; page <= totalPages; page++) {
              if (page === initialPage) continue;
              const url = new URL(first);
              url.searchParams.set(this.dataset.pageParam, String(page));
              url.searchParams.set('section_id', this.dataset.sectionId);
              const controller = new AbortController();
              const abort = () => controller.abort();
              signal.addEventListener('abort', abort, { once: true });
              const timer = setTimeout(abort, 15000);
              let html;
              try {
                const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
                if (!response.ok) throw new Error('response');
                html = await response.text();
              } finally {
                clearTimeout(timer);
                signal.removeEventListener('abort', abort);
              }
              if (signal.aborted) return;
              const document = new DOMParser().parseFromString(html, 'text/html');
              const archive = document.querySelector('iv-model-archive');
              if (!archive || archive.dataset.sectionId !== this.dataset.sectionId || Number(archive.dataset.currentPage) !== page || Number(archive.dataset.totalPages) !== totalPages) throw new Error('pagination');
              archive.querySelectorAll('[data-iv-archive-card]').forEach(card => {
                const id = card.dataset.modelId;
                if (!id || seen.has(id)) return;
                seen.add(id);
                card.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; image.setAttribute('fetchpriority', 'auto'); });
                grid.append(window.document.importNode(card, true));
              });
              cards = [...grid.querySelectorAll('[data-iv-archive-card]')];
              fillOptions();
              update();
            }
            complete = true;
          } catch (error) {
            if (!signal.aborted) failed = true;
          } finally {
            loading = false;
            if (!signal.aborted) update();
          }
        };
        const filter = () => { resultPage = 1; update(); void loadAll(); };
        const options = { signal };
        form.addEventListener('submit', event => { event.preventDefault(); filter(); }, options);
        form.addEventListener('input', filter, options);
        form.addEventListener('change', filter, options);
        form.addEventListener('reset', event => {
          event.preventDefault();
          form.elements.namedItem('model-search').value = '';
          form.elements.namedItem('brand').value = '';
          form.elements.namedItem('scale').value = '';
          form.elements.namedItem('in-stock').checked = false;
          filter();
        }, options);
        this.querySelector('[data-iv-retry]').addEventListener('click', () => { void loadAll(); }, options);
        this.querySelector('[data-iv-previous]').addEventListener('click', () => { resultPage--; update(); }, options);
        this.querySelector('[data-iv-next]').addEventListener('click', () => { resultPage++; update(); }, options);
        fillOptions();
        update();
        form.hidden = false;
        void loadAll();
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
